{
  "title": "Reality Capture (local)",
  "url": "http://localhost:3000/index.html",
  "icon": "http://localhost:3000/assets/logo_darkgray_24dp.svg",
  "description": "Publish, visualize and catalogue Reality Capture data",
  "configCommand": "config_command",
  "extensionType": ["project", "3dviewer"],
  "enabled": true
}
